import { render, staticRenderFns } from "./new_report_whole.vue?vue&type=template&id=3d684e20&scoped=true&"
import script from "./new_report_whole.vue?vue&type=script&lang=js&"
export * from "./new_report_whole.vue?vue&type=script&lang=js&"
import style1 from "./new_report_whole.vue?vue&type=style&index=1&id=3d684e20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d684e20",
  null
  
)

export default component.exports